<template>
  <div>
    <div class="newYear" id="newYear">
      <div class="newYear_banner" id="newYear_banner">
          <img class="newYear_banner_img" src="http://img.source.9188cn.com/newYear_banner.jpg">
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='newYear_recommend'">
            <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" class="newYear_recommend" id="newYear_recommend">
              <div class="newYear_recommend_list clearfix_">
                  <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="newYear_recommend_item fl">
                      <img class="newYear_recommend_item_bg" src="http://img.source.9188cn.com/newYear_recommend2.png">
                      <img class="newYear_recommend_item_img" :src="val.pic">
                  </div>
              </div>
            </div>
          </div>
      </div>
      <div class="newYear_content">
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='newYear_goods1'||item.parentName=='newYear_goods1_copy1'||item.parentName=='newYear_goods1_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="newYear_goods1" id="newYear_goods1">
              <div class="newYear_goods1_title">
                  <div class="newYear_goods1_title_txt">{{item.title}}</div>
              </div>
              <div class="newYear_goods1_list">
                  <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="newYear_goods1_item clearfix_">
                      <div class="fl newYear_goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
                      <div class="fr newYear_goods1_item_txt">
                          <div class="newYear_goods1_item_name1">{{val.name}}</div>
                          <div class="newYear_goods1_item_name2">{{val.goodsSellPoint}}</div>
                          <div class="newYear_goods1_item_price clearfix_"><b class="fl">促销价：</b><span class="fl">{{val.beforePrice}}</span><i class="fl">{{val.afterPrice}}</i></div>
                          <div class="newYear_goods1_item_btn clearfix_"><div class="newYear_goods1_item_btn_txt fr">立即抢购</div></div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='newYear_goods2'||item.parentName=='newYear_goods2_copy1'||item.parentName=='newYear_goods2_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="newYear_goods1" id="newYear_goods2">
              <div class="newYear_goods1_title">
                  <div class="newYear_goods1_title_txt">{{item.title}}</div>
              </div>
              <div class="newYear_goods1_list">
                  <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="newYear_goods1_item clearfix_">
                      <div class="fl newYear_goods1_item_txt">
                          <div class="newYear_goods1_item_name1">{{val.name}}</div>
                          <div class="newYear_goods1_item_name2">{{val.goodsSellPoint}}</div>
                          <div class="newYear_goods1_item_price clearfix_"><b class="fl">促销价：</b><span class="fl">{{val.beforePrice}}</span><i class="fl">{{val.afterPrice}}</i></div>
                          <div class="newYear_goods1_item_btn clearfix_"><div class="newYear_goods1_item_btn_txt fr">立即抢购</div></div>
                      </div>
                      <div class="fr newYear_goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
                  </div>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='newYear_goods3'||item.parentName=='newYear_goods3_copy1'||item.parentName=='newYear_goods3_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="newYear_goods3" id="newYear_goods3">
              <div class="newYear_goods1_title">
                  <div class="newYear_goods1_title_txt">{{item.title}}</div>
              </div>
              <div class="newYear_goods3_list clearfix_">
                  <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="newYear_goods3_item fl">
                      <div class="newYear_goods3_item_img"><img :src="val.pic?val.pic:noImg"></div>
                      <div class="newYear_goods3_item_name1">{{val.name}}</div>
                      <div class="newYear_goods3_item_name2">{{val.goodsSellPoint}}</div>
                      <div class="newYear_goods3_item_price"><b>促销价：</b><span>{{val.beforePrice}}</span><i>{{val.afterPrice}}</i></div>
                      <div class="newYear_goods1_item_btn_txt newYear_goods3_item_btn_txt">立即抢购</div>
                  </div>
              </div>
              <div class="newYear_goods3_item_doll1"></div>
              <div class="newYear_goods3_item_doll2"></div>
            </div>
          </div>
          <div class="newYear_bottom"><img src="http://img.source.9188cn.com/newYear_bottom_bg.png"></div>
          <div class="newYear_doll_left"></div>
          <div class="newYear_doll_right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
    gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
    },
    goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
    },
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
        t_.allData=res.data.results
        }else{
          return this.$router.push({path: '/'})
        }
      })
    }
  }
}
</script>

<style scoped>
  .newYear_banner{
      position: relative;
  }
  .newYear_banner_img{
      width: 100%;
  }
  .newYear_recommend{
      width: 800px;
      position: absolute;
      left: 50%;
      bottom: 60px;
      margin-left:-400px;
  }
  .newYear_recommend_item{
      margin-right: 9px;
      width: 260px;
      height: 177px;
      position: relative;
  }
  .newYear_recommend_item:last-child{
      margin-right: 0;
  }
  .newYear_recommend_item_bg{
      width: 260px;
      height: 177px;
      position: absolute;
      top: 0;
      left: 0;
  }
  .newYear_recommend_item_img{
      width: 260px;
      height: 177px;
  }
  .newYear_content{
      padding-bottom: 200px;
      position: relative;
      background: #d13131 url("http://img.source.9188cn.com/newYear_bg.png");
      background-size: 100%;
  }
  .newYear_doll_left{
      width: 330px;
      height: 280px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("http://img.source.9188cn.com/newYear_goods3_left.png");
      background-size: 100%;
  }
  .newYear_doll_right{
      width: 330px;
      height: 280px;
      position: absolute;
      top: 0;
      left: 0;
      background: url("http://img.source.9188cn.com/newYear_goods3_right.png");
      background-size: 100%;
  }
  .newYear_goods1{
      width: 800px;
      position: relative;
      z-index: 9;
      margin: 0 auto;
      margin-bottom: 60px;
  }
  .newYear_goods1_title{
      width: 800px;
      height: 90px;
      background: url('http://img.source.9188cn.com/newYear_title.png');
      background-size: 100%;
      position: relative;
      margin-bottom: 20px;
  }
  .newYear_goods1_title_txt{
      width: 300px;
      height: 50px;
      position: absolute;
      left: 50%;
      top: 19px;
      margin-left: -150px;
      color: #02194d;
      font-size: 34px;
      line-height: 50px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      text-align: center;
  }
  .newYear_goods1_item{
      width: 720px;
      /*height: 264px;*/
      background: url("http://img.source.9188cn.com/newYear_goods1_bg.png");
      background-size: 100%;
      padding: 42px 40px 44px 40px;
      margin-bottom: 30px;
  }
  .newYear_goods1_item_img{
      width: 270px;
      height: 270px;
  }
  .newYear_goods1_item_img img{
      width: 270px;
      height: 270px;
  }
  .newYear_goods1_item_txt{
      width: 400px;
      margin-top: 25px;
  }
  .newYear_goods1_item_name1{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 32px;
      color: #feee99;
      margin-bottom: 30px;
  }
  .newYear_goods1_item_name2{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 26px;
      color: #feee99;
      margin-bottom: 30px;
  }
  .newYear_goods1_item_price{
      color: #feee99;
      margin-bottom: 30px;
  }
  .newYear_goods1_item_price b{
      font-size: 18px;
      margin-top: 18px;
  }
  .newYear_goods1_item_price span{
      font-size: 40px;
  }
  .newYear_goods1_item_price i{
      font-size: 20px;
      margin-top: 18px;
  }
  .newYear_goods1_item_btn_txt{
      width: 144px;
      height: 42px;
      background: url("http://img.source.9188cn.com/newYear_goods1_btn.png");
      background-size: 100%;
      font-size: 22px;
      color: #333;
      text-align: center;
      line-height: 42px;
  }
  .newYear_goods3{
      width: 800px;
      margin: 0 auto;
      position: relative;
      z-index: 9;
      margin-bottom: 60px;
  }
  .newYear_goods3_list{
      width: 720px;
      height: 1073px;
      background: url("http://img.source.9188cn.com/newYear_goods3_bg.png");
      background-size: 100%;
      padding: 40px;
  }
  .newYear_goods3_item{
      width: 335px;
      margin-bottom: 60px;
      margin-right: 48px;
  }
  .newYear_goods3_item:nth-child(2n){
      margin-right: 0;
  }
  .newYear_goods3_item:nth-child(3),.newYear_goods3_item:nth-child(4){
      margin-bottom: 0;
  }
  .newYear_goods3_item_img{
      width: 335px;
      height: 335px;
      margin-bottom: 10px;
  }
  .newYear_goods3_item_img img{
      width: 335px;
      height: 335px;
  }
  .newYear_goods3_item_name1{
      padding: 0 20px;
      font-size: 29px;
      text-align: center;
      color: #fdee99;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 10px;
  }
  .newYear_goods3_item_name2{
      padding: 0 20px;
      font-size: 22px;
      height: 22px;
      text-align: center;
      color: #fdee99;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 10px;
  }
  .newYear_goods3_item_price{
      font-size: 18px;
      color: #fdee99;
      padding: 0 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 10px;
  }
  .newYear_goods3_item_price span{
      font-size: 40px;
  }
  .newYear_goods3_item_btn_txt{
      margin: 0 auto;
  }
  .newYear_bottom{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
  }
  .newYear_bottom img{
      width: 100%;
  }
  .newYear_goods3_item_doll1{
      width: 330px;
      height: 280px;
      background: url("http://img.source.9188cn.com/newYear_goods3_left.png");
      background-size: 100%;
      position: absolute;
      bottom: 40px;
      left: -328px;
  }
  .newYear_goods3_item_doll2{
      width: 330px;
      height: 280px;
      background: url("http://img.source.9188cn.com/newYear_goods3_right.png");
      background-size: 100%;
      position: absolute;
      top: 350px;
      right: -324px;
  }

</style>



// WEBPACK FOOTER //
// src/components/newYear/newYear.vue